import {
  createRoute,
  lazyRouteComponent,
  redirect,
} from '@tanstack/react-router';
import { REVENUE_ROUTES } from '../constants/routes.constants';
import { appLayoutRoute } from '../../layout';
import { useAuthStore } from '@/features/auth/stores/auth.store';
import { hasRole } from '@/shared/utils/rbac.utils';
import ROUTE_CONSTANTS from '@/shared/constants/route.constants';
import { ROLES } from '@/features/rbac';

const checkSuperAdmin = () => {
  const user = useAuthStore.getState().user;
  if (!hasRole(user, ROLES.SUPER_ADMIN)) {
    throw redirect({ to: ROUTE_CONSTANTS.ROOT, replace: true });
  }
};

const revenueListRoute = createRoute({
  path: REVENUE_ROUTES.LIST,
  getParentRoute: () => appLayoutRoute,
  component: lazyRouteComponent(() =>
    import('../pages').then(m => ({ default: m.RevenueManagementPage }))
  ),
  beforeLoad: async () => {
    checkSuperAdmin();
  },
});

export const revenueRoutes = [revenueListRoute];

export default revenueRoutes;
